// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__27fYW","errorLogs":"styles_errorLogs__185sk"};